














































import Vue from 'vue';
import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import { mapState } from 'vuex';
import HMTableButton from '@/web/components/common/HMTableButton.vue';
import moment from 'moment';
import { saveAs } from '@/web/utils/save-file';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  components: {
    HMTableButton,
    TopNav,
    NavItem,
  },
  computed: {
    ...mapState('setting', ['invoiceHistory', 'currencies']),
  },
  methods: {
    formatInvoiceDate(date) {
      return moment(date).format('llll');
    },
    async downloadPurchaseInvoice(purchase) {
      try {
        const data = await this.$store.dispatch(
          'user/downloadTeacherPurchaseInvoice',
          purchase.id
        );
        const blob = new Blob([data], {
          type: 'application/pdf;charset=utf-8;',
        });
        saveAs(blob, `order-${purchase.id}.pdf`);
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Downloading invoice failed',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
  },
  mounted() {
    this.$store.dispatch('setting/getInvoiceHistory');
  },
});
